/**
 * All icon names that are supported by the component.
 */
export enum DisplayType {
    Error,
    Information,
    Success,
    Feedback,
    Warning
}
